import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IAgent, IAgentState } from "./agentModel";
import { agentActiveInactive,  createAgent, deleteAgent, getAgentByID, getAllActiveAgent, getAllAgent, updateAgent } from "./services/agent.services";

const initialState: IAgentState = {
  loading: false,
  formLoading: false,
  error: "",
  AgentList: [],
  AgentID: null,
  AgentDetail: {
    agent_name: "",
    mobile: "",
    email: "",
    address: "",
    contact_person: "",
isactive: 1,
  },
};

const agentSlice = createSlice({
  name: "agent",
  initialState,
  reducers: {
    clearAgentDetails: (state) => {
      state.AgentDetail = initialState.AgentDetail;
    },
    setAgentID: (state, action) => {
      state.AgentID = action.payload;
    },
    clearAgentID: (state) => {
      state.AgentID = initialState.AgentID;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAllAgent.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllAgent.fulfilled,
      (state, action: PayloadAction<IAgent[]>) => {
        state.loading = false;
        state.AgentList = action.payload || [];
      }
    );
    builder.addCase(getAllAgent.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.AgentList = [];
    });
    builder.addCase(getAllActiveAgent.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllActiveAgent.fulfilled,
      (state, action: PayloadAction<IAgent[]>) => {
        state.loading = false;
        state.AgentList = action.payload || [];
      }
    );
    builder.addCase(getAllActiveAgent.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.AgentList = [];
    });
    builder.addCase(createAgent.pending, (state) => {
      state.formLoading = false;
      state.error = "";
    });
    builder.addCase(createAgent.fulfilled, (state) => {
      state.formLoading = false;
    });
    builder.addCase(createAgent.rejected, (state, action) => {
      state.formLoading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(updateAgent.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(updateAgent.fulfilled, (state) => {
      state.formLoading = false;
    });
    builder.addCase(updateAgent.rejected, (state, action) => {
      state.formLoading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(deleteAgent.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(deleteAgent.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(deleteAgent.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(agentActiveInactive.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(agentActiveInactive.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(agentActiveInactive.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(getAgentByID.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(getAgentByID.fulfilled, (state, action: any) => {
      state.formLoading = false;
      state.AgentDetail = action.payload;
    });
    builder.addCase(getAgentByID.rejected, (state, action) => {
      state.formLoading = false;
      state.AgentDetail = initialState.AgentDetail;
      state.error = action.error.message || "Something went wrong";
    });
  },
});

export const { clearAgentDetails, setAgentID, clearAgentID } =
  agentSlice.actions;
export default agentSlice.reducer;
